import React, { useState } from 'react';
import styles from './contactform.module.css';

export default function ContactForm() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const res = await fetch('https://contact-api-production-2a74.up.railway.app/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, message }),
      });

      if (res.ok) {
        setStatus('success');
        setEmail('');
        setMessage('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return React.createElement(
    'form',
    { onSubmit: handleSubmit, className: styles.form },
    React.createElement('h2', { className: styles.title }, 'Contáctame'),

    // Email input
    React.createElement('div', null,
      React.createElement('label', { className: styles.label }, 'Correo electrónico'),
      React.createElement('input', {
        type: 'email',
        className: styles.input,
        required: true,
        value: email,
        onChange: (e) => setEmail(e.target.value),
      })
    ),

    // Message textarea
    React.createElement('div', null,
      React.createElement('label', { className: styles.label }, 'Comentario'),
      React.createElement('textarea', {
        rows: 4,
        className: styles.textarea,
        required: true,
        value: message,
        onChange: (e) => setMessage(e.target.value),
      })
    ),

    // Submit button
    React.createElement('button', {
      type: 'submit',
      className: styles.button,
      disabled: status === 'loading',
    }, status === 'loading' ? 'Enviando...' : 'Enviar'),

    // Status messages
    status === 'success' &&
      React.createElement('p', { className: styles.success }, '¡Mensaje enviado correctamente!'),
    status === 'error' &&
      React.createElement('p', { className: styles.error }, 'Error al enviar el mensaje.')
  );
}
